import config from 'config';

import { buildURL } from '~/techstyle-shared/redux-core';

export const femaleUrlPaths = {
  '.com': '/hc/en-us',
  '.ca': '/hc/en-ca',
  '.co.uk': '/hc/en-gb',
  '.de': '/hc/de-ch',
  '.dk': '/hc/da',
  '.es': '/hc/es',
  '.fr': '/hc/fr-be',
  '.nl': '/hc/en-be',
  '.se': '/hc/sv',
};

export const maleUrlPaths = {
  '.com': '/hc/en-au',
  '.ca': '/hc/en-ph',
  '.co.uk': '/hc/en-ie',
  '.fr': '/hc/fr-ch',
  '.de': '/hc/de',
  '.es': '/hc/es-es',
};

const helpPageUrl = config.get('public.helpPageUrl');
const globalMembershipPrice = config.get('public.brand.globalMembershipPrice');

export default function getHelpPageUrl({
  domain,
  gender,
  membership,
  membershipPriceTestDetailRecord,
}) {
  const { tld = '.com' } = domain || {};
  const { isMale } = gender || {};
  const membershipPrice = membership?.price;
  const globalPrice = globalMembershipPrice?.[tld];

  const currentPathMap = isMale ? maleUrlPaths : femaleUrlPaths;
  const localePath = currentPathMap[tld] || currentPathMap['.com'];
  const fullUrl = `${helpPageUrl}${localePath}`;

  if (membershipPriceTestDetailRecord?.value) {
    return buildURL(fullUrl, { tsps: '69.95' });
  }

  if (tld === '.co.uk' && membershipPrice === 44) {
    return buildURL(fullUrl, { tsps: '44' });
  }

  if (membershipPrice && globalPrice && globalPrice !== membershipPrice) {
    return buildURL(fullUrl, { tsps: String(membershipPrice) });
  }

  return fullUrl;
}
